import { useState, useEffect } from 'react'
import { serviceAPI } from '../services/serviceService'

export const useSEOTags = () => {
  const [tags, setTags] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchTags = async () => {
      try {
        setLoading(true)
        const response = await serviceAPI.getAllTags({ active: true })
        
        // Response'u kontrol et ve uygun formata çevir
        let tagsArray = []
        if (Array.isArray(response)) {
          tagsArray = response
        } else if (response && typeof response === 'object') {
          tagsArray = Object.keys(response)
        }
        
        setTags(tagsArray)
      } catch (err) {
        console.error('SEO tags fetch error:', err)
        setError(err)
        // Fallback tags
        setTags([
          'doğal gaz tesisatı',
          'su tesisatı',
          'kombi bakım onarım',
          'klima servisi',
          'beyaz eşya servisi',
          'kaçak su tespiti',
          'kalorifer tesisatı',
          'kart tamiri',
          'yedek parça'
        ])
      } finally {
        setLoading(false)
      }
    }

    fetchTags()
  }, [])

  const generateMetaTags = () => {
    if (!tags.length) {
      return {
        keywords: 'doğal gaz tesisatı, su tesisatı, kombi bakım onarım, klima servisi, beyaz eşya servisi, Karabük teknik servis',
        description: 'Buğra Teknik Servis - Karabük\'te profesyonel teknik servis hizmetleri. Doğal gaz tesisatı, su tesisatı, kombi bakım onarım ve daha fazlası.',
        tags: []
      }
    }

    const keywords = tags.slice(0, 10).join(', ') // İlk 10 etiketi al
    const description = `Buğra Teknik Servis - ${tags.slice(0, 5).join(', ')} hizmetleri. Karabük'te profesyonel teknik servis. 14+ yıl deneyim, 1000+ mutlu müşteri.`

    return {
      keywords,
      description,
      tags: tags
    }
  }

  return {
    tags,
    loading,
    error,
    generateMetaTags
  }
}
